/**
 * 首页标题2
 */

import { Row, Col } from 'antd';

const HH2 = () => {
    return <>
        <div style={{ backgroundColor: '#fff', marginTop: '30px' }}>
            <Row>
                <Col offset={4} span={16} style={{ textAlign: 'center' }}>
                    <h1>项目服务</h1>
                    <p>为您提供信息化一站式服务</p>
                </Col>
            </Row>
        </div>
    </>
}

export default HH2;